import { ComponentRef, Component, ElementRef, ViewEncapsulation, inject, input, effect } from '@angular/core';

import { ApComponentInjectionService } from '@ap/cdk';

import { ApIconComponent } from '../icon.component';

@Component({
    selector: 'li[apListIcon]',
    templateUrl: './list-icon.component.html',
    styleUrls: ['./list-icon.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApListIconComponent {
    private readonly elementRef = inject(ElementRef);
    private readonly componentInjectionService = inject(ApComponentInjectionService);

    /**
     * Required - Name of the icon to show.
     */
    public readonly name = input.required<string>();

    /**
     * The icon color (the `fill` attribute is used).
     * Available: `secondary`, `inherit`, `success`, `warning`, `error`, `disabled`.
     */
    public readonly color = input<string>(undefined);

    private icon: ComponentRef<any>;

    constructor() {
        effect(() => {
            if (this.icon) {
                this.componentInjectionService.removeComponent(this.icon);
            }
            this.createIcon(this.color(), this.name());
        });
    }

    private createIcon(color: string, name: string) {
        const icon = this.componentInjectionService.injectComponent(
            ApIconComponent,
            new Map<string, any>([
                ['color', color],
                ['name', name]
            ])
        );

        this.elementRef.nativeElement.insertAdjacentElement('afterbegin', icon.element);
        this.icon = icon.componentRef;
    }
}
